import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import { chunk, merge } from 'lodash-es';

import DownloadRequestLandingPageLayout from '../layouts/DownloadRequestLandingPageLayout';
import { Data } from '../components';

const TopBlock = ({ article }) => {
  const chunks = chunk(article.frontmatter.authors.items, 3);

  return (
    <section className="section">
      <div className="container">
        <div className="section-titleWrapper">
          <h3 className="section-title">
            <Data>{article.frontmatter.authors.heading}</Data>
          </h3>
        </div>
        {chunks.map((partial, index) => {
          const key = `authors_${index}`;

          return (
            <Fragment key={key}>
              {index !== 0 && <hr className="u-mv--large" />}
              <ul className="blockGrid blockGrid-3@small blockGrid--largeGutter blockGrid--xlargeGutter@medium">
                {partial.map(item => (
                  <li key={item.name}>
                    <h4 className="u-textFluid--xlarge u-mb--small">
                      {item.name}
                    </h4>
                    <div className="u-textMuted u-textHeading u-textNormal">
                      {item.title}
                    </div>
                    <img
                      className="oreilly__company-logo"
                      src={item.logo}
                      alt={item.company}
                    />
                  </li>
                ))}
              </ul>
            </Fragment>
          );
        })}
      </div>
    </section>
  );
};

TopBlock.propTypes = {
  article: PropTypes.object.isRequired,
};

const OReillyReducingMttdForHighSeverityIncidents = ({
  overrides,
  data: { article },
}) => {
  const articleData = merge(article, overrides);

  return (
    <DownloadRequestLandingPageLayout
      article={articleData}
      topBlock={<TopBlock article={articleData} />}
      nodeType="landing-page"
    />
  );
};

OReillyReducingMttdForHighSeverityIncidents.propTypes = {
  data: PropTypes.object.isRequired,
  overrides: PropTypes.object,
};

export default OReillyReducingMttdForHighSeverityIncidents;

export const pageQuery = graphql`
  query OReillyReducingMttdForHighSeverityIncidentsSingle {
    article: markdownRemark(
      fileAbsolutePath: {
        regex: "/src/data/oreilly-reducing-mttd-for-high-severity-incidents.md/"
      }
    ) {
      fileAbsolutePath
      frontmatter {
        seoTitle
        description
        slug
        hero {
          headingSub
          heading
          blurb
          form {
            embed
            heading
          }
        }
        authors {
          heading
          items {
            name
            title
            company
            logo
          }
        }
        leftColumnContent
        rightColumnContent
        showFooterCTA
        showProductOverview
      }
    }
  }
`;
